<template>
  <AnalyticsWidget
    title="Collection Performance"
    subTitle="List of recent orders picked up and their delay times"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">
    <div class="p-2 h-100">
      <LoadingPanel :loading="loading" />
      <Scroller maxHeight="330" height="330">
        <AnalyticsBreakdownTable>
          <template v-slot:header>
            <tr>
              <th>Order</th>
              <th>Customer</th>
              <th>Ready Date</th>
              <th>Collection Date</th>
              <th><Tooltip label="Business days the order was waiting collection" helpStyle>Days Waiting</Tooltip></th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="order of recentOrderList" :key="order.id">
              <td><LinkOrder :id="order.id" :name="order.sequenceNumber" /></td>
              <td><LinkContact :id="order.contact.id" :name="order.contact.name" /></td>
              <td>{{formatDate(order.dateProductionCompleted || order.dateDespatchStarted)}}</td>
              <td>{{formatDate(order.dateClosed)}}</td>
              <td>{{order.despatchDurationDays}}</td>
            </tr>
          </template>
        </AnalyticsBreakdownTable>
      </Scroller>
    </div>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'

export default {
  name: 'OrderDIFOTCollectionTaskPerformanceWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable
  },
  props: {
    contactId: Number,
    filter: Object,
    gridWidth: Number,
    gridHeight: Number
  },
  data() {
    return {
      loading: false,
      recentOrderList: []
    }
  },
  computed: {
    
  },
  watch: {
    contactId: function() {
      this.requestData()
    },
    filter: function() {
      this.requestData()
    }
  },
  mounted() {
    this.requestData()

    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestData() {
      this.loading = true

      var params = {
        contactId: this.contactId,
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
        maxOrderCount: 20
      }

      this.$apiService.analyticsService.getOrderDIFOTRecentCollectionList(params)
      .then(response => {
        this.recentOrderList = response.data
      })
      .finally(() => {
        this.loading = false
      })     
    },
  }
}
</script>
